<div class="global-search">
  <mat-form-field class="search-bar" appearance="outline">
    <mat-chip-grid #chipList class="chip-list">
      @for (term of searchTerms; track term) {
        <mat-chip-row (removed)="removeSearchTerm(term)">
          {{ term }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input
        #searchInputVC
        id="searchInputVC"
        [placeholder]="isFetchingResults ? 'Fetching Results...' : 'Search All'"
        class="search-input"
        autocomplete="off"
        [disabled]="isFetchingResults"
        matInput
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (keyup.enter)="onKeyPressed($event)"
        (keyup.,)="onKeyPressed($event)"
        (keyup.;)="onKeyPressed($event)"
        (input)="onInputChange($event)"
        (focus)="onInputFocus()"
      />
      <div class="search-tooltip">
        @if (showMinTermLengthTooltip) {
          <div class="search-tooltip--wrapper">
            <div class="search-tooltip--arrow"></div>
            <p>Provide a search query with at least three characters</p>
          </div>
        }
      </div>
      <div class="search-tooltip">
        @if (showDuplicateTermsTooltip) {
          <div class="search-tooltip--wrapper">
            <div class="search-tooltip--arrow"></div>
            <p>Provide a different search term, this one is repeated</p>
          </div>
        }
      </div>
    </mat-chip-grid>
  </mat-form-field>
  <!-- recent-search -->
  @if (showRecentSearches) {
    <div class="recent-search">
      <div class="left-wrapper">
        <div class="recent-search__title">Search History</div>
        @if (recentSearches.length > 0) {
          <div class="recent-search__items">
            @for (terms of recentSearches; track terms) {
              <div
                class="recent-search__item"
                (click)="onRecentSearchClicked(terms)"
                tabindex="0"
                (keydown.enter)="onRecentSearchClicked(terms)"
              >
                <div class="recent-search__item--img">
                  <img src="../../../../../assets/images/icons/icon-update.svg" alt="update-icon" />
                </div>
                <span>{{ terms.join(', ') }}</span>
              </div>
            }
          </div>
        } @else {
          <div class="recent-search__empty" data-testid="recent-search-empty-state">No recent searches</div>
        }
      </div>
      <div class="right-wrapper">
        <button
          (click)="clearRecentSearches()"
          tabindex="0"
          (keydown.enter)="clearRecentSearches()"
          data-testid="recent-search-clear-all-button"
        >
          Clear All
        </button>
      </div>
    </div>
  }
  <!-- search-results -->
  @if (showSearchResults) {
    <div class="global-search-results">
      @for (
        searchResult of sortedSearchResults;
        track searchResult.serviceAddon + searchResult.results.total;
        let i = $index
      ) {
        <div class="global-search-results__wrapper">
          <app-search-results
            [searchResult]="searchResult"
            (onResultClickedEmitter)="onResultClicked()"
            [renderFilterType]="renderFilterType"
          ></app-search-results>
          <!-- divider line -->
          @if (i !== searchResults.length - 1) {
            <div class="global-search-results__divider"></div>
          }
        </div>
      }
    </div>
  }
  @if (isFetchingResults) {
    <div class="search-button">
      <mat-spinner [diameter]="26" [strokeWidth]="2" color="primary"></mat-spinner>
    </div>
  } @else {
    <button
      type="button"
      title="Search"
      class="search-button"
      [disabled]="disableSearchButton()"
      [ngClass]="{ 'search-button--disabled': disableSearchButton() }"
      (click)="onSearchIconClicked()"
    >
      <img src="../../../assets/images/icons/icon_search_blue.svg" alt="" />
    </button>
  }

  <mat-select class="search-filter-type" panelClass="myMatSelectOverlay" [(value)]="filterType">
    <mat-select-trigger class="search-filter-trigger" data-testid="global-search-type-selector">
      <span>{{ renderFilterType(filterType) }}</span
      ><mat-icon class="text-white">keyboard_arrow_down</mat-icon>
    </mat-select-trigger>
    @for (type of filterTypes; track type) {
      <mat-option data-testid="global-search-type-option" [value]="type">{{ renderFilterType(type) }} </mat-option>
    }
  </mat-select>
</div>
